<template>
    <div class="apprentice-simple-card dashboard-quick-options-widget">
        <div class="component-title">
            <h5 class="title">{{ $t('dashboard.quick_links') }}</h5>
        </div>

        <div>
            <div class="invite">
                <div class="icon d-none d-lg-block"><i class="fad fa-fw fa-plus"></i></div>
                <div class="title">
                    {{ $t('dashboard.new_project') }}
                    <div class="invite-type muted-text">{{ $t('dashboard.start_a_new_project') }}</div>
                </div>
                <div class="invite-show">
                    <b-button
                        class="btn-open"
                        variant="primary-icon-only"
                        href="#">
                    </b-button>
                </div>
                <a
                    class="clickable"
                    :href="'/group/create'"></a>
            </div>
            <div class="invite">
                <div class="icon d-none d-lg-block"><i class="fad fa-fw fa-users-cog"></i></div>
                <div class="title">
                    {{ $t('dashboard.accounts') }}
                    <div class="invite-type muted-text">{{ $t('dashboard.account_list_for_this_school') }}</div>
                </div>
                <div class="invite-show">
                    <b-button
                        class="btn-open"
                        variant="primary-icon-only"
                        href="#">
                    </b-button>
                </div>
                <a
                    class="clickable"
                    :href="'/school/accounts'"></a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-dashboard-quick-options-component',
    methods: {},
};
</script>

<style scoped lang="scss">
.dashboard-quick-options-widget {
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');

    .info-text {
        color: $text-muted-color;
        font-size: $default-font-size;
    }

    .info-text,
    .invite {
        margin-bottom: map-get($grid-gutter-spacing, 'ten');
    }

    .invite {
        display: flex;
        justify-content: flex-start;
        align-content: center;
        font-size: 1.3125rem;
        position: relative;
        padding-top: map-get($grid-gutter-spacing, 'ten');

        .icon {
            align-self: center;
            padding: map-get($grid-gutter-spacing, 'ten');
            background: $secondary-background-color;
            border-radius: $border-radius-content;
            color: $primary;
        }

        .title {
            font-size: $default-font-size;
            font-family: $headings-font-family;
            line-height: 1;
            align-self: center;
        }

        .invite-show,
        .invite-action {
            align-self: center;
            margin-left: auto;

            .btn {
                font-size: 1.3125rem;
            }
        }

        &:hover {
            cursor: pointer;

            .icon {
                color: $inverse-info;
            }

            .title {
                font-weight: $font-weight-medium;
                color: $primary;
            }

            .invite-show .btn {
                color: $nav-link-color;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .invite {
        .title {
            margin-right: map-get($grid-gutter-spacing, 'ten');
        }
    }

    .page-wrapper.navbar-toggled {
        .invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'ten');
            }
            .icon {
                display: flex !important;
            }
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .dashboard-quick-options-widget {
        .invite {
            .title {
                margin-left: map-get($grid-gutter-spacing, 'fifteen');
                margin-right: map-get($grid-gutter-spacing, 'fifteen');
            }
        }
    }
}
</style>
